import { createContext } from 'react';

export interface Environment {
  clientId: string;
  admins: string[];
}
export const EnvironmentContext = createContext<Environment>({ clientId: '', admins: [] });
